module.exports = "/_next/static/images/GearedL-5de3ff153ea24d7728650c01a9e1f394.png";